export default __webpack_public_path__ + "static/watch-children-f252fe16ff2631cb1be5bace19888012.png";